import React from 'react';

import { IStrapiMediaData } from 'types';

interface IProps {
  image: IStrapiMediaData;
  media?: string;
}

const StrapiImageSource: React.FunctionComponent<IProps> = ({ image, media = '', ...rest }) => {
  const host = image.url.split(image.hash)[0];
  const webpUrl = `${host}${image.hash}.webp`;

  // We don't want to render a source set for svg images
  if (image.ext === '.svg') return null;

  return (
    <>
      <source srcSet={webpUrl} media={media} type="image/webp" {...rest} />
    </>
  );
};

export default StrapiImageSource;
